<div class="login-container">
  <div class="login-card">
    <div class="logo-section">
      <img src="assets/brand_white.svg" alt="BHA Logo" class="logo-image">
    </div>
    <h1 class="login-title">STEWARDS</h1>
    <button type="submit" class="btn btn-primary login-button" (click)="login()">
      <span>Sign in</span>
    </button>
    <div class="version-info">Release: Periwinkle r5</div>
  </div>
</div>

<!--
Lavender
Plum
Magenta
Periwinkle
Eggplant
Heather
Orchid
Fandango
Violet
Ultra
Electric
-->
